import React from "react";
import { useLang } from "@/context/LanguageContext";

const Cookies = () => {
  const { lang } = useLang();
  const en = lang === "en";
  return (
    <section className="bg-[#F7F5F0]" data-testid="cookies-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-32 pb-24">
        <p className="text-xs uppercase tracking-[0.3em] text-[#5C7567] mb-4">Cookies</p>
        <h1 className="font-display text-4xl sm:text-5xl text-[#1A2E24]">
          {en ? "Cookies" : "Cookies"}
        </h1>
        <p className="mt-6 text-[#3B5245] leading-relaxed">
          {en
            ? "Lotusgruppen.dk is built to be privacy-friendly. The site does not set marketing cookies and does not use third-party advertising or cross-site tracking."
            : "Lotusgruppen.dk er bygget til at være privatlivsvenlig. Siden sætter ikke marketingcookies og bruger ikke tredjeparts annoncering eller sporing på tværs af sites."}
        </p>
        <p className="mt-4 text-[#3B5245] leading-relaxed">
          {en
            ? "The site stores a single local preference in your browser to remember your chosen language. Anonymous, aggregated usage events may be recorded to improve the site; they do not contain your name, email, phone or message text."
            : "Siden gemmer en enkelt lokal indstilling i din browser for at huske dit valgte sprog. Anonyme, aggregerede brugshændelser kan registreres for at forbedre siden; de indeholder ikke dit navn, e-mail, telefon eller beskedtekst."}
        </p>
        <p className="mt-4 text-[#3B5245] leading-relaxed">
          {en
            ? "No consent banner for marketing or statistics cookies is shown, because such cookies are not used."
            : "Der vises ikke et samtykkebanner for marketing- eller statistikcookies, fordi sådanne cookies ikke anvendes."}
        </p>
        <p className="mt-12 text-xs text-[#5C7567]">
          {en
            ? "This text reflects the current technical setup and is pending final legal review before go-live."
            : "Denne tekst afspejler den nuværende tekniske løsning og afventer endelig juridisk gennemgang før go-live."}
        </p>
      </div>
    </section>
  );
};

export default Cookies;
